"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StoreForm = _interopRequireDefault(require("./components/StoreForm.vue"));
var _rsManagement = require("@/api/rsManagement");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as storeApi from '@/api/storeApi'
var _default = exports.default = {
  name: 'StoreList',
  components: {
    StoreForm: _StoreForm.default
  },
  data: function data() {
    return {
      // 搜索表单数据
      pageFrom: {
        page: 1,
        limit: 20,
        keywords: '',
        supplierId: '',
        status: '',
        businessStatus: '',
        regionId: [],
        storeTypes: [],
        online: '',
        wmTgFlag: []
      },
      // 表格数据
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      // 店铺表单弹窗相关
      storeFormVisible: false,
      isEditMode: false,
      currentStoreData: {},
      currentStoreId: null,
      // 商户选项
      merchantOptions: [],
      filteredMerchantOptions: [],
      merchantLoading: false,
      searchTimer: null,
      // 地区选项
      areaOptions: [],
      // 店铺类型选项（来自数据字典 ykt_industry_type）
      storeTypeOptions: [],
      wmTgFlagOptions: [{
        value: '1',
        label: '实物',
        type: 'success'
      }, {
        value: '2',
        label: '团购',
        type: 'success'
      }, {
        value: '3',
        label: '酒店',
        type: 'success'
      }]
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.initData();
          case 1:
            this.getList();
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    formatTicketTemplateNames: function formatTicketTemplateNames(value) {
      if (value == null || value === '') return '-';
      if (Array.isArray(value)) {
        var names = value.filter(function (item) {
          return item != null && String(item).trim() !== '';
        });
        return names.length ? names.join('、') : '-';
      }
      return String(value) || '-';
    },
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var reqData, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              reqData = JSON.parse(JSON.stringify(this.pageFrom)); // 处理地区ID，取最后一个值
              console.log('搜索前的地区参数:', reqData.regionId);
              if (reqData.regionId && reqData.regionId.length > 0) {
                reqData.regionId = reqData.regionId[reqData.regionId.length - 1];
                console.log('处理后取最后一个地区ID:', reqData.regionId);
              } else {
                reqData.regionId = '';
                console.log('地区参数为空');
              }
              if (Array.isArray(reqData.wmTgFlag)) {
                reqData.wmTgFlag = reqData.wmTgFlag.join(',');
              }
              if (Array.isArray(reqData.storeTypes)) {
                reqData.storeTypes = reqData.storeTypes.join(',');
              }
              _context2.p = 1;
              _context2.n = 2;
              return (0, _rsManagement.getStoreList)(reqData);
            case 2:
              res = _context2.v;
              if (res) {
                this.tableData.list = res.list || [];
                this.tableData.total = res.total || 0;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error('获取店铺列表失败：', _t);
              this.$message.error('获取数据失败：' + (_t.message || '未知错误'));
              this.tableData.list = [];
              this.tableData.total = 0;
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.pageFrom = {
        page: 1,
        limit: 20,
        keywords: '',
        supplierId: '',
        status: '',
        businessStatus: '',
        regionId: [],
        storeTypes: [],
        online: '',
        wmTgFlag: []
      };
      // 重置商户选项过滤
      this.filteredMerchantOptions = _toConsumableArray(this.merchantOptions);
      this.getList();
    },
    getWmTgFlagList: function getWmTgFlagList(wmTgFlag) {
      var _this = this;
      if (wmTgFlag === null || wmTgFlag === undefined || wmTgFlag === '') {
        return [];
      }
      var values = Array.isArray(wmTgFlag) ? wmTgFlag : String(wmTgFlag).split(',');
      return values.map(function (item) {
        var option = _this.wmTgFlagOptions.find(function (opt) {
          return opt.value === String(item).trim();
        });
        return option || null;
      }).filter(Boolean);
    },
    getStoreStatusText: function getStoreStatusText(storeStatus) {
      if (storeStatus === 1) {
        return '已开业';
      }
      if (storeStatus === 0) {
        return '筹备中';
      }
      return '已停用';
    },
    getStoreStatusTagType: function getStoreStatusTagType(storeStatus) {
      if (storeStatus === 1) {
        return 'success';
      }
      if (storeStatus === 0) {
        return 'warning';
      }
      return 'info';
    },
    getCurrentBusinessStatusTagType: function getCurrentBusinessStatusTagType(status) {
      if (status === '营业中') {
        return 'success';
      }
      if (status === '休息中') {
        return 'warning';
      }
      return 'info';
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    // 添加店铺
    addStore: function addStore() {
      this.isEditMode = false;
      this.currentStoreData = {};
      this.currentStoreId = null;
      this.storeFormVisible = true;
    },
    // 编辑店铺
    editStore: function editStore(row) {
      this.isEditMode = true;
      this.currentStoreId = row.id;
      this.storeFormVisible = true;
    },
    // 查看店铺
    viewStore: function viewStore(row) {
      this.$message.info("\u67E5\u770B\u5E97\u94FA\uFF1A".concat(row.storeName));
      // 跳转到详情页面或打开弹窗
    },
    // 删除店铺
    deleteStore: function deleteStore(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5E97\u94FA\"".concat(row.storeName, "\"\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _rsManagement.deleteStore)(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.getList();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.error('删除店铺失败：', _t2);
              _this2.$message.error('删除失败：' + (_t2.message || '未知错误'));
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    // 初始化数据
    initData: function () {
      var _initData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.getMerchantList();
            case 1:
              this.getAreaData();
              this.fetchStoreTypeOptions();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }(),
    // 获取商户列表
    getMerchantList: function () {
      var _getMerchantList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.merchantLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return (0, _rsManagement.getSupplierAutoList)();
            case 2:
              res = _context5.v;
              if (res && Array.isArray(res)) {
                this.merchantOptions = res.map(function (item) {
                  return {
                    value: Number(item.id || item.supplierId),
                    label: item.supplierName || item.name
                  };
                });
                this.filteredMerchantOptions = _toConsumableArray(this.merchantOptions);
                console.log('Index: merchantOptions updated', this.merchantOptions);
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              console.error('获取商户列表失败：', _t3);
              this.$message.error('获取商户列表失败');
            case 4:
              _context5.p = 4;
              this.merchantLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function getMerchantList() {
        return _getMerchantList.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    // 过滤商户选项
    filterMerchants: function filterMerchants(query) {
      if (query === '') {
        this.filteredMerchantOptions = this.merchantOptions;
      } else {
        this.filteredMerchantOptions = this.merchantOptions.filter(function (item) {
          return item.label.toLowerCase().includes(query.toLowerCase());
        });
      }
    },
    // 远程搜索商户
    remoteSearchMerchants: function remoteSearchMerchants(query) {
      var _this3 = this;
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 设置防抖延迟
      this.searchTimer = setTimeout(function () {
        if (query !== '') {
          _this3.merchantLoading = true;
          // 这里可以调用带搜索参数的接口
          (0, _rsManagement.getSupplierAutoList)({
            keywords: query
          }).then(function (res) {
            if (res && Array.isArray(res)) {
              _this3.filteredMerchantOptions = res.map(function (item) {
                return {
                  value: Number(item.id || item.supplierId),
                  label: item.supplierName || item.name
                };
              });
            } else {
              _this3.filteredMerchantOptions = [];
            }
          }).catch(function (err) {
            console.error('搜索商户失败：', err);
            _this3.$message.error('搜索商户失败');
            _this3.filteredMerchantOptions = [];
          }).finally(function () {
            _this3.merchantLoading = false;
          });
        } else {
          _this3.filteredMerchantOptions = _this3.merchantOptions;
        }
      }, 300); // 300ms 防抖延迟
    },
    // 获取地区数据
    getAreaData: function getAreaData() {
      var _this4 = this;
      dangaoActApi.getShopSelfAddress().then(function (res) {
        console.log('获取到的地区数据:', res);
        _this4.areaOptions = res || [];
        console.log('设置后的areaOptions:', _this4.areaOptions);
      }).catch(function (err) {
        console.error('获取地区数据失败：', err);
        _this4.$message.error('获取地区数据失败');
      });
    },
    // 获取店铺类型选项（eb_merchant_store_type 全量）
    fetchStoreTypeOptions: function () {
      var _fetchStoreTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return (0, _rsManagement.getMerchantStoreTypeList)();
            case 1:
              res = _context6.v;
              this.storeTypeOptions = (res || []).map(function (item) {
                return {
                  value: Number(item.key),
                  label: item.value
                };
              }).filter(function (item) {
                return item.value && item.label;
              });
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t4 = _context6.v;
              console.error('获取店铺类型选项失败:', _t4);
              this.storeTypeOptions = [];
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function fetchStoreTypeOptions() {
        return _fetchStoreTypeOptions.apply(this, arguments);
      }
      return fetchStoreTypeOptions;
    }(),
    // 处理店铺表单提交
    handleStoreSubmit: function handleStoreSubmit(formData) {
      if (this.isEditMode) {
        // 编辑店铺
        // storeApi.updateStore(formData).then(() => {
        this.$message.success('编辑店铺成功');
        this.storeFormVisible = false;
        this.getList();
        // })
      } else {
        // 添加店铺
        // storeApi.addStore(formData).then(() => {
        this.$message.success('添加店铺成功');
        this.storeFormVisible = false;
        this.getList();
        // })
      }
    }
  }
};